module.exports = __webpack_public_path__ + "static/assets/0317a67d3300cdb6b69cc5f8605f058e.gif";